import styles from './SelStage.module.css'
import picStage1 from '../Img/Stage/stage1.png'
import picStage2 from '../Img/Stage/stage2.png'
import picStage3 from '../Img/Stage/stage3.png'
import picStage4 from '../Img/Stage/stage4.png'
import picStage5 from '../Img/Stage/stage5.png'
import picArrow from '../Img/Stage/arrow.png'
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setMainMenuId} from "../Reducer/GlobalReducer";
export default function SellStage(){
    const navigate = useNavigate();
    const dispatch = useDispatch()

    return(
        <div className={styles.mainCont}>

            <div>
                <div className={[styles.orTitle,""].join(' ')}>
                    Как сделать заказ
                </div>
                <div>
                    <div className={styles.lineCont}>
                        <div className={styles.itmCont}
                            onClick={()=>{
                                dispatch(setMainMenuId(3))
                                navigate('/menu/choose')
                            }}
                        >
                            <img className={styles.stImg} src={picStage1}></img>
                            <div>Выбор тарифа</div>
                        </div>
                        <div className={styles.arrCont}><img src={picArrow} className={styles.arr}></img></div>
                        <div className={styles.itmCont} style={{cursor:"inherit"}}>
                            <img className={styles.stImg} src={picStage2}></img>
                            <div>Оформление</div>
                        </div>
                        <div className={styles.arrCont}><img src={picArrow} className={styles.arr}></img></div>
                        <div className={styles.itmCont}
                            onClick={()=>{
                                dispatch(setMainMenuId(2))
                                navigate('/menu/payment')}}
                        >
                            <img className={styles.stImg} src={picStage3}></img>
                            <div>Оплата</div>
                        </div>
                        <div className={styles.arrCont}><img src={picArrow} className={styles.arr}></img></div>
                        <div className={styles.itmCont}
                             onClick={()=>{
                                 dispatch(setMainMenuId(1))

                                 navigate('/menu/delivery')}}
                        >
                            <img className={styles.stImg} src={picStage4}></img>
                            <div>Доставка</div>
                        </div>
                        <div className={styles.arrCont}><img src={picArrow} className={styles.arr}></img></div>
                        <div className={styles.itmCont}
                             onClick={()=>{
                                 dispatch(setMainMenuId(5))
                                 navigate('/menu/activate')}}
                        >
                            <img className={styles.stImg} src={picStage5}></img>
                            <div>Активация</div>
                        </div>

                    </div>

                </div>

            </div>



        </div>
    )
}